import { useState, useEffect } from "react";
import { 
  savePurchaseRequisition,
  getPRTypes,
  getItemTypes,
  getItems,
  getUnits,
  getRequestedForOptions,
  getMerchants,
  getResources
} from "../Api/PurchaseRequisition";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const PurchaseRequisition = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [requestedForCodeLoading, setRequestedForCodeLoading] = useState(false);
  const [prTypes, setPrTypes] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [resources, setResources] = useState([]);
  const [requestedForOptions, setRequestedForOptions] = useState([]);
  const [requestedForCodeOptions, setRequestedForCodeOptions] = useState([]);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const staticRequestedForOptions = [
    { value: "Resource", label: "Resource" },
    { value: "Department", label: "Department" },
    { value: "Cost Center", label: "Cost Center" },
    { value: "Cost Center Group", label: "Cost Center Group" },
    { value: "Office", label: "Office" },
    { value: "Company", label: "Company" }
  ];

  const [purchaseData, setPurchaseData] = useState({
    prType: "",
    purchaseItemType: "",
    item: "",
    quantity: "",
    unit: "",
    requestedDeliveryDate: "",
    requestedFor: "",
    requestedForCode: "",
    preferredVendor: "",
    requestedBy: ""
  });

  useEffect(() => {
    const fetchDropdownData = async () => {
      setDropdownLoading(true);
      try {
        const [
          prTypesData, 
          itemTypesData, 
          itemsData, 
          unitsData,
          merchantsData,
          resourcesData
        ] = await Promise.all([
          getPRTypes(),
          getItemTypes(),
          getItems(),
          getUnits(),
          getMerchants(),
          getResources()
        ]);
        setPrTypes(prTypesData);
        setItemTypes(itemTypesData);
        setItems(itemsData);
        setUnits(unitsData);
        setMerchants(merchantsData);
        setResources(resourcesData);
        setRequestedForOptions(staticRequestedForOptions);
      } catch (error) {
        toast.error("Error loading dropdown data");
      } finally {
        setDropdownLoading(false);
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    const fetchRequestedForCodeOptions = async () => {
      if (purchaseData.requestedFor) {
        setRequestedForCodeLoading(true);
        try {
          const options = await getRequestedForOptions(purchaseData.requestedFor);
          setRequestedForCodeOptions(options);
          setPurchaseData(prev => ({ ...prev, requestedForCode: "" }));
        } catch (error) {
          toast.error(`Error loading ${purchaseData.requestedFor} options`);
          setRequestedForCodeOptions([]);
        } finally {
          setRequestedForCodeLoading(false);
        }
      } else {
        setRequestedForCodeOptions([]);
      }
    };

    fetchRequestedForCodeOptions();
  }, [purchaseData.requestedFor]);

  const handleChange = (e) => {
    setPurchaseData({ ...purchaseData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await savePurchaseRequisition(purchaseData, userId);
      toast.success("🦄 Purchase Requisition Added Successfully");
      setPurchaseData({
        prType: "",
        purchaseItemType: "",
        item: "",
        quantity: "",
        unit: "",
        requestedDeliveryDate: "",
        requestedFor: "",
        requestedForCode: "",
        preferredVendor: "",
        requestedBy: ""
      });
      navigate("/viewPurchaseRequisition");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand"> 
          <Container fluid className="fields-container">
            <h2 className="fields-title">Purchase Requisition</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              {/* Row 1 */}
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>PR Type <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="prType"
                      value={purchaseData.prType}
                      onChange={handleChange}
                      required
                      disabled={dropdownLoading}
                    >
                      <option value="">Select PR Type</option>
                      {prTypes.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Purchase Item Type <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="purchaseItemType"
                      value={purchaseData.purchaseItemType}
                      onChange={handleChange}
                      required
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Item Type</option>
                      {itemTypes.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="item"
                      value={purchaseData.item}
                      onChange={handleChange}
                      required
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Item</option>
                      {items.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 2 */}
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Quantity <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="quantity"
                      value={purchaseData.quantity}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Unit <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="unit"
                      value={purchaseData.unit}
                      onChange={handleChange}
                      required
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Unit</option>
                      {units.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Requested Delivery Date <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="requestedDeliveryDate"
                      value={purchaseData.requestedDeliveryDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3 */}
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Requested For <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="requestedFor"
                      value={purchaseData.requestedFor}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Requested For</option>
                      {requestedForOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Requested For Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="requestedForCode"
                      value={purchaseData.requestedForCode}
                      onChange={handleChange}
                      required
                      disabled={!purchaseData.requestedFor || requestedForCodeLoading}
                    >
                      <option value="">Select {purchaseData.requestedFor || "Option"}</option>
                      {requestedForCodeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Preferred Vendor</Form.Label>
                    <Form.Control
                      as="select"
                      name="preferredVendor"
                      value={purchaseData.preferredVendor}
                      onChange={handleChange}
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Vendor</option>
                      {merchants.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 4 */}
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Requested By <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="requestedBy"
                      value={purchaseData.requestedBy}
                      onChange={handleChange}
                      required
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Requested By</option>
                      {resources.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Purchase Requisition
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {(loading || dropdownLoading || requestedForCodeLoading) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default PurchaseRequisition;